import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import { ProductContext } from '../../App';

function EditPayment(props) {

    const product_context = useContext(ProductContext);
    const { setIsLoading, alert, setAlert } = product_context;

    const { editPaymnet, setEditPayment, reload } = props;

    const { isOpen, payment } = editPaymnet;

    const [editInputs, setEditInputs] = useState({
        name: '',
        amount: 0,
    })

    useEffect(() => {
        setEditInputs({
            name: payment?.name,
            amount: payment?.amount,
        })
        // eslint-disable-next-line
    }, [isOpen])

    const handleChange = (e) => {
        let { name, value } = e.target;
        setEditInputs({ ...editInputs, [name]: value });
    }

    const handlePaymentSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);

        let data = {
            name: editInputs?.name,
            amount: editInputs?.amount,
        }

        axios.put(`${process.env.REACT_APP_SERVER_DOMAIN}/payment/${payment._id}`, data)
            .then(res => {
                setAlert({
                    isOpen: true,
                    message: "Payment Updated",
                    type: 'success'
                });
                setIsLoading(false);
                setEditPayment({ ...editPaymnet, isOpen: false });
                reload();
            })
            .catch(err => {
                setAlert({
                    isOpen: true,
                    message: "Something went wrong",
                    type: 'danger'
                });
                setIsLoading(false);
            })

        setTimeout(() => {
            setAlert({ ...alert, isOpen: false })
        }, 5000);
    }


    return (
        <>
            {isOpen ? <div className='back'>
                <div className="edit-container flex-column">
                    <h2>Edit Payment</h2>
                    <div className="edit-form">
                        <form onSubmit={handlePaymentSubmit}>

                            <div className="inputs">
                                <label htmlFor="name">Name</label>
                                <input type="text"
                                    value={editInputs?.name}
                                    required
                                    placeholder='Enter Name' name='name'
                                    onChange={(e) => { handleChange(e) }}
                                />
                            </div>

                            <div className="inputs">
                                <label htmlFor="amount">Amount</label>
                                <input type="number"
                                    value={editInputs?.amount}
                                    required
                                    placeholder='Enter Amount' name='amount'
                                    onChange={(e) => { handleChange(e) }}
                                />
                            </div>
                            <div>
                                <button type='submit' className='btn btn-success mx-2'>Submit</button>
                                <button onClick={() => {
                                    setEditPayment({ ...editPaymnet, isOpen: false });
                                }} className='btn btn-danger'>Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div> : null}
        </>
    )
}

export default EditPayment
